import { render, staticRenderFns } from "./BackgroundCheckConsent.vue?vue&type=template&id=e2a160c0&"
import script from "./BackgroundCheckConsent.vue?vue&type=script&lang=js&"
export * from "./BackgroundCheckConsent.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundCheckConsent.vue?vue&type=style&index=0&id=e2a160c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports